import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';

const UserOptions = ({
	authorise,
	decline,
	view,
	viewAll,
	hideAll,
	edit,
	cancel,
	handleAuthorise,
	handleDecline,
	handleView,
	handleViewAll,
	handleHideAll,
	handleEdit,
	handleCancel,
	id,
	paymentUploadView,
	review,
}) => (
	<div>
		{authorise && (
			<Button id={`authorise-button-${id}`} width="flush" onClick={handleAuthorise}>
				Authorise
			</Button>
		)}
		{review && (
			<Button id={`paymentUploadReview-button-${id}`} width="flush" onClick={handleAuthorise}>
				Review
			</Button>
		)}
		{decline && (
			<Button id={`decline-button-${id}`} width="flush" onClick={handleDecline}>
				Decline
			</Button>
		)}
		{view && (
			<Button id={`view-button-${id}`} width="flush" onClick={handleView}>
				View
			</Button>
		)}
		{paymentUploadView && (
			<Button id={`paymentUploadView-button-${id}`} width="flush" onClick={handleAuthorise}>
				View
			</Button>
		)}
		{viewAll && (
			<Button id={`viewall-button-${id}`} width="flush" onClick={handleViewAll}>
				View All
			</Button>
		)}
		{hideAll && (
			<Button id={`hideall-button-${id}`} width="flush" onClick={handleHideAll}>
				Hide All
			</Button>
		)}
		{edit && (
			<Button id={`edit-button-${id}`} width="flush" onClick={handleEdit}>
				Edit
			</Button>
		)}
		{cancel && (
			<Button id={`cancel-button-${id}`} width="flush" onClick={handleCancel}>
				Cancel
			</Button>
		)}
	</div>
);

UserOptions.propTypes = {
	authorise: PropTypes.bool,
	decline: PropTypes.bool,
	view: PropTypes.bool,
	viewAll: PropTypes.bool,
	hideAll: PropTypes.bool,
	edit: PropTypes.bool,
	cancel: PropTypes.bool,
	handleAuthorise: PropTypes.func,
	handleDecline: PropTypes.func,
	handleView: PropTypes.func,
	handleViewAll: PropTypes.func,
	handleHideAll: PropTypes.func,
	handleEdit: PropTypes.func,
	handleCancel: PropTypes.func,
	id: PropTypes.string,
	paymentUploadView: PropTypes.bool,
	review: PropTypes.bool,
};

export default UserOptions;
